export default __webpack_public_path__ + "static/media/Shower - Grey.d42382bd.svg";